
window._ = require('lodash');


/**
 * Add ES6 promise
 */

import 'es6-promise/auto'
import 'babel-polyfill';

if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
        navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
            // Registration was successful
            console.log('Registered!');
        }, function(err) {
            // registration failed :(
            console.log('ServiceWorker registration failed: ', err);
        }).catch(function(err) {
            console.log(err);
        });
    });
} else {
    console.log('service worker is not supported');
}